import IconWrapper from "./IconWrapper";

function UserIcon() {
  return (
    <IconWrapper>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path fill="none" d="M16 0v16H0V0z" />
        <path d="M8.472 8.45l.985-.592a3.77 3.77 0 0 0 1.729-2.338 3.772 3.772 0 0 0-.43-2.876A3.77 3.77 0 0 0 7.502.8H7.5a3.773 3.773 0 0 0-3.255 1.844 3.804 3.804 0 0 0 1.3 5.214l.985.592L1 11.772V15h13v-3.229L8.472 8.45zM6.06 7.001a2.805 2.805 0 0 1-.958-3.843A2.784 2.784 0 0 1 7.501 1.8c.992.002 1.888.51 2.398 1.358a2.804 2.804 0 0 1-.958 3.843l-1.44.865-1.441-.865zM13 14H2v-1.662l5.501-3.305L13 12.337V14z" />
      </svg>
    </IconWrapper>
  );
}

export default UserIcon;
